import { render, staticRenderFns } from "./seeVersionModel.vue?vue&type=template&id=8810aa2e"
import script from "./seeVersionModel.vue?vue&type=script&lang=js"
export * from "./seeVersionModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8810aa2e')) {
      api.createRecord('8810aa2e', component.options)
    } else {
      api.reload('8810aa2e', component.options)
    }
    module.hot.accept("./seeVersionModel.vue?vue&type=template&id=8810aa2e", function () {
      api.rerender('8810aa2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/applicationVersionManage/seeVersionModel.vue"
export default component.exports